import { createListenerMiddleware } from '@reduxjs/toolkit';
import { navigateToThunk } from '../../core/navigation/navigationSlice.js';
import { inlineFormActions } from './inlineFormSlice.js';
import { dynamicMiddleware } from '../../index.js';
import { setActiveView } from '../../core/wrapperContext/wrapperContextSlice.js';
let formNavigationMiddlewareInstance;
const formNavigationMiddlewareOptions = {
    actionCreator: navigateToThunk.fulfilled,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners();
        listenerApi.dispatch(inlineFormActions.changeForm(action.payload));
        listenerApi.dispatch(setActiveView(action.payload));
    },
};
const addFormNavigationMiddleware = () => {
    formNavigationMiddlewareInstance = createListenerMiddleware();
    formNavigationMiddlewareInstance.startListening(formNavigationMiddlewareOptions);
    dynamicMiddleware.addMiddleware(formNavigationMiddlewareInstance.middleware);
};
const removeFormNavigationMiddleware = () => {
    if (formNavigationMiddlewareInstance) {
        dynamicMiddleware.removeMiddleware(formNavigationMiddlewareInstance.middleware);
        formNavigationMiddlewareInstance = null;
    }
};
export const formNavigationMiddleware = {
    add: addFormNavigationMiddleware,
    remove: removeFormNavigationMiddleware,
};
//# sourceMappingURL=formNavigationMiddleware.js.map